import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: '0', label: 'Unspecified' },
    { value: '1', label: 'Authenticator' },
    { value: '2', label: 'Email' },
    { value: '3', label: 'Text' },
  ],
});
